<template>
    <div class="invoice-card">
        <div
            v-for="(data, idx) in dataList"
            :key="`${idx}-card`"
            class="m-d-16"
            :class="{ 'is-progress':  isProgressExport(data) }"
        >
            <SOSlotCard
                :id="`card-${data.idmasal_transaksi}`"
                :last-id="getLastId"
                :card-type="typeCard"
                @loadMore="doLoadMore"
                @toogleCard="toggleCard"
                :dropdown-menu="`card`"
            >
                <template v-slot:before_head>
                    <div
                        v-if="isProgressExport(data)"
                        class="f-c-midgrey"
                    >
                        <span class="spinner-border spinner-border-sm f-c-midgrey " role="status" aria-hidden="true"></span>
                        <span class="pl-2 ">
                            Sedang Memproses File Invoice...
                        </span>
                    </div>
                    <div v-else>
                        <div class="notification expired" v-if="data.error_msg">
                            <label class="m-d-0">
                                <span> Error: {{data.error_msg}} </span>
                            </label>
                        </div>
                        <template v-else>
                            <div class="notification need-confirm" v-if="data.status_pembatalan === 1">
                                <label class="m-d-0">
                                    <span> Menunggu konfirmasi pembatalan </span>
                                </label>
                            </div>
                            <div class="notification expired" v-if="data.status_pembatalan === 2">
                                <label class="m-d-0">
                                    <span> Invoice Dibatalkan </span>
                                </label>
                            </div>
                            <div class="notification expired" v-if="isExpired(data, $moment)">
                                <label class="m-d-0">
                                    <SOIconBase view-box="0 0 12 12" width="14" height="14">
                                        <template v-slot:icon>
                                            <TandaseruLingkaran1212 icon-fill="#964040" />
                                        </template>
                                    </SOIconBase>
                                    <span>
                                        Lewat Jatuh Tempo Pelunasan ({{ $moment(data.jatuh_tempo).format("Do MMM YYYY") }})
                                    </span>
                                </label>
                            </div>
                        </template>
                    </div>
                </template>
                <template v-slot:card_head>
                    <div class="d-flex-between-center">
                        <div class="">
                            <span v-if="searchKey" v-html="searchHighlight(data.idmasal_transaksi, searchKey)"> </span>
                            <span v-else>{{ data.idmasal_transaksi }}</span>
                        </div>
                        <div>
                            <SOIconBase view-box="0 0 24 24" width="24" height="24">
                                <template v-slot:icon>
                                    <MoreMenu2424 />
                                </template>
                            </SOIconBase>
                        </div>
                    </div>
                </template>
                <template v-slot:card_body>
                    <div class="c-body">
                        <p class="m-d-0 f-13">
                            <SOIconBase view-box="0 0 16 16" width="16" height="16">
                                <template v-slot:icon>
                                    <MoodHappy1616 />
                                </template>
                            </SOIconBase>
                            <span> {{ data.counter_konsumen }} Konsumen • </span>
                            <span v-if="searchKey" v-html="searchHighlight(data.penerima, searchKey)"></span>
                            <span v-else>{{ data.penerima }}</span>
                        </p>
                        <p class="m-d-0 f-13">
                            <SOIconBase view-box="0 0 16 16" width="16" height="16">
                                <template v-slot:icon>
                                    <OutletOut1616 />
                                </template>
                            </SOIconBase>
                            <span v-if="searchKey" v-html="searchHighlight(data.nama_outlet, searchKey)"></span>
                            <span v-else> {{ data.nama_outlet }} </span>
                        </p>
                        <p class="m-d-0 f-13">
                            <span>Dibuat {{ dateFormated(data.created_at, $moment) }} oleh </span>
                            <span v-if="isOwner(data.idkaryawan, data.nama_karyawan)">Owner</span>
                            <span v-else>{{ data.nama_karyawan }}</span>
                        </p>
                        <p class="m-d-0 f-12">
                            <span>Keterangan: {{ data.keterangan }}</span>
                        </p>
                    </div>
                </template>
                <template v-slot:card_footer>
                    <div class="d-flex-between-center c-foot">
                        <div class="">
                            <p class="m-d-0 f-14 f-semi">
                                Rp {{ data.sisa_bayar | decimal }}
                                <label class="lunas" v-if="isLunas(data)">Lunas</label>
                                <label class="belum-bayar" v-else>Blm Bayar</label>
                                <label class="lunas" v-if="isLunas(data)">{{ getMetodeBayar(data.idjenisbayar) }}</label>
                            </p>
                        </div>
                        <div class="">
                            <p class="m-d-0 f-12 f-c-midgrey">{{ data.jumlah_transaksi }} Transaksi</p>
                        </div>
                    </div>
                </template>
                <template v-slot:menu_card>
                    <div>
                        <p class="dropdown-item p-x-8 m-d-0" @click="goDetail(data)" v-if="validateAccess('list.read')">
                            <SOIconBase view-box="0 0 20 20" width="20" height="20">
                                <template v-slot:icon>
                                    <FileText2020 />
                                </template>
                            </SOIconBase>
                            <span class="m-l-4">Detail Invoice</span>
                        </p>
                        <div class="separator-line" v-if="data.status_pembatalan !== 2"></div>
                        <p class="dropdown-item p-x-8 m-d-0" v-if="data.status_pembatalan !== 2 && data.url_invoice !== ''" @click="download(data)">
                            <SOIconBase view-box="0 0 20 20" width="20" height="20">
                                <template v-slot:icon>
                                    <ClipCheck2020 />
                                </template>
                            </SOIconBase>
                            <span class="m-l-4">Download Invoice</span>
                        </p>
                        <p class="dropdown-item p-x-8 m-d-0" @click="goExport(data)" v-if="data.status_pembatalan !== 2">
                            <SOIconBase view-box="0 0 20 20" width="20" height="20">
                                <template v-slot:icon>
                                    <File2020 />
                                </template>
                            </SOIconBase>
                            <span class="m-l-4">Ekspor Lampiran</span>
                        </p>
                        <div class="separator-line" v-if="data.status_pembatalan !== 2"></div>
                        <p class="dropdown-item p-x-8 m-d-0" @click="confirmSend(data)" v-if="data.status_pembatalan !== 2">
                            <SOIconBase view-box="0 0 14 14" width="19" height="19">
                                <template v-slot:icon>
                                    <WhatsappIcon1414 />
                                </template>
                            </SOIconBase>
                            <span class="m-l-4">Kirim Invoice</span>
                        </p>
                        <div class="separator-line" v-if="!isLunas(data) && data.status_pembatalan == 0 && validateAccess('list.payoff')"></div>
                        <p
                            class="dropdown-item p-x-8 m-d-0"
                            @click="goPembayaran(data)"
                            v-if="!isLunas(data) && data.status_pembatalan !== 2 && validateAccess('list.payoff')"
                        >
                            <SOIconBase view-box="0 0 20 20" width="20" height="20">
                                <template v-slot:icon>
                                    <Uang2020 />
                                </template>
                            </SOIconBase>
                            <span class="m-l-4">Lunasi Invoice</span>
                        </p>
                        <div
                            class="separator"
                            style="margin-left: 0px; margin-right: 0px"
                            v-if="data.status_pembatalan !== 2 && data.status_pembatalan !== 1 && validateAccess('list.delete')"
                        ></div>
                        <p
                            class="dropdown-item p-x-8 m-d-0"
                            @click="goPembatalan(data)"
                            v-if="data.status_pembatalan == 0 && validateAccess('list.delete')"
                        >
                            <span class="m-l-4">
                                <SOIconBase view-box="0 0 12 12" width="14" height="14">
                                    <template v-slot:icon>
                                        <CloseX1212 iconFill="#DA1E28" />
                                    </template>
                                </SOIconBase>
                            </span>
                            <span class="m-l-4">Batalkan Invoice</span>
                        </p>
                        <div class="separator-line"></div>
                        <p class="dropdown-item p-x-8 m-d-0" @click="goDeleteInvoice(data)" v-if="data.status_pembatalan == 2 && validateAccess('list.delete')">
                            <SOIconBase view-box="0 0 20 20" width="20" height="20">
                                <template v-slot:icon>
                                    <Trash2020 />
                                </template>
                            </SOIconBase>
                            <span class="m-l-4">Hapus</span>
                        </p>
                    </div>
                </template>
            </SOSlotCard>
        </div>
        <SOModalConfirm
            title="Ekspor"
            :body="`${exportData.data.length} File belum didownload. Apakah anda yakin ingin melanjutkan & menghapus file tersebut?`"
            button-text="Oke, menengerti"
            ref="confirmExport"
            outline
            :primary="false"
        />
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";
import resulter from "@/store/utils/resulter";
import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import TandaseruLingkaran1212 from "@/so-components/global/icons/iconPacks/TandaseruLingkaran1212.vue";
import MoreMenu2424 from "@/so-components/global/icons/iconPacks/MoreMenu2424.vue";
import MoodHappy1616 from "@/so-components/global/icons/iconPacks/MoodHappy1616.vue";
import OutletOut1616 from "@/so-components/global/icons/iconPacks/OutletOut1616.vue";
import FileText2020 from "@/so-components/global/icons/iconPacks/FileText2020.vue";
import File2020 from "@/so-components/global/icons/iconPacks/File2020.vue";
import ClipCheck2020 from "@/so-components/global/icons/iconPacks/ClipCheck2020.vue";
import Trash2020 from "@/so-components/global/icons/iconPacks/Trash2020.vue";
import WhatsappIcon1414 from "@/so-components/global/icons/iconPacks/WhatsappIcon1414.vue";
import Uang2020 from "@/so-components/global/icons/iconPacks/Uang2020.vue";
import CloseX1212 from "@/so-components/global/icons/iconPacks/CloseX1212.vue";
import SOModalConfirm from "@/so-components/global/modal/SOModalConfirm.vue";
import metodeBayar from "../static/metodeBayar.js";

import { moduleName } from "../store/state";

export default {
    name: "CardInvoice",
    props: {
        typeCard: {
            type: String,
            default: "shadow",
        },
        searchKey: {
            type: String || Number,
            default: "",
        },
        dataList: {
            type: Array,
            default: function () {
                return [];
            },
        },
        loadData: {
            type: Function,
            required: true,
        },
    },
    components: {
        SOSlotCard,
        SOIconBase,
        TandaseruLingkaran1212,
        MoreMenu2424,
        MoodHappy1616,
        OutletOut1616,
        FileText2020,
        File2020,
        ClipCheck2020,
        Trash2020,
        WhatsappIcon1414,
        Uang2020,
        CloseX1212,
        metodeBayar,
        SOModalConfirm,
    },
    data() {
        return {
            socketKey: "export.invoice.progress.",
        }
    },
    sockets: {
        connect: () => {
            console.log("socket connected");
        },
    },
    mounted() {
        this.subscribeInvoice();
    },
    beforeDestroy() {
        this.unsubscribeInvoice();
    },
    computed: {
        ...mapGetters(moduleName, {
            invoiceEnd: "invoiceEnd",
            dateFormated: "dateFormated",
            isOwner: "isOwner",
            invoiceTotal: "invoiceTotal",
            invoicePage: "invoicePage",
            isLoadMore: "isLoadMore",
            exportData: "exportData",
        }),
        getLastId() {
            return this.invoiceEnd.idmasal_transaksi ? `card-${this.invoiceEnd.idmasal_transaksi}` : "";
        },
        isExpired() {
            return (data, moment) => {
                let currentDate = moment();
                let expiredDate = moment(data.jatuh_tempo);

                if (
                    expiredDate.diff(currentDate) < 0 &&
                    !this.isLunas(data) &&
                    data.status_pembatalan !== 1 &&
                    data.status_pembatalan !== 2
                )
                    return true;
                return false;
            };
        },
        isLunas() {
            return (data) => {
                return data.lunas === 1;
            };
        },
        getMetodeBayar() {
            return (idjenisbayar) => {
                let metode = metodeBayar.find((m) => m.value == idjenisbayar);
                return metode.title ? metode.title : "";
            };
        },
    },
    methods: {
        ...mapActions({
            toggleInvoiceShow: `${moduleName}/toggleInvoiceShow`,
            setLoadMore: `${moduleName}/setLoadMore`,
            sendWaInvoice: `${moduleName}/sendWaInvoice`,
            setResponse: `${moduleName}/setResponse`,
            exportLampiran: `${moduleName}/exportLampiran`,
            toggleExport: `${moduleName}/toggleExport`,
        }),
        isProgressExport(data) {
            return data.kriteria_json != "" && data.url_invoice == "" && data.created_at > 1660186841000 && (data.error_msg == "" || data.error_msg == null);
        },
        subscribeInvoice() {
            this.dataList.forEach((data) => {
                if (this.isProgressExport(data)) {
                    this.sockets.subscribe(this.socketKey + data.idmasal_transaksi, async (report) => {
                        const result = JSON.parse(report);
                        if (result.progress == 2) {
                            data.url_invoice = result.url_invoice;
                            this.sockets.unsubscribe(this.socketKey + data.idmasal_transaksi);
                        }
                        if (result.progress == 3) {
                            data.error_msg = result.error_msg;
                            let invoiceExportFail = localStorage.getItem("invoiceExportFail");
                            if (invoiceExportFail) {
                                invoiceExportFail = JSON.parse(invoiceExportFail);
                            } else {
                                localStorage.setItem("invoiceExportFail", JSON.stringify([data.idmasal_transaksi]));
                            }
                        }
                    });
                }
            });
        },
        unsubscribeInvoice() {
            this.dataList.forEach((v) => {
                this.sockets.unsubscribe(this.socketKey + v.id);
            });
        },
        goExport(data) {
            if (this.exportData.exporting) {
                this.$toast.warning('Sedang melakukan export...')
                return
            }
            if (this.exportData.data.length) {
                this.$refs.confirmExport.open().then(acc => {
                    if (acc) {
                        this.$refs.confirmExport.close()
                        this.toggleExport(true);
                        this.exportLampiran({ idInvoice: data.idmasal_transaksi });
                    }
                });
            } else {
                this.toggleExport(true);
                this.exportLampiran({ idInvoice: data.idmasal_transaksi });
            }
        },
        goDetail(data) {
            this.$router.push({ name: "invoice.detail", params: { invoiceId: data.idmasal_transaksi } });
        },
        goPembayaran(data) {
            this.$router.push({ name: "invoice.detail.pembayaran", params: { invoiceId: data.idmasal_transaksi } });
        },
        goPembatalan(invoice) {
            this.$router.push({
                name: "invoice.list.pembatalan_invoice",
                params: { invoiceId: invoice.idmasal_transaksi },
                query: {
                    pembayaran: invoice.jenis_bayar,
                    idKaryawan: invoice.idkaryawan,
                    isLunas: invoice.lunas === 1,
                    nominal: invoice.sisa_bayar,
                    idAkun: encodeURI(invoice.idakun),
                },
            });
        },
        download(data){
            const flutterConfig = JSON.parse(localStorage.getItem('flutterConfig'))
			if (this.isWebview() && flutterConfig.platform !== 'web') {
				this.flutterDownload(data.url_invoice);
			} else {
				window.open(data.url_invoice, '_blank');
			}
        },
        confirmSend(data) {
            this.$router.push({
                name: "invoice.send.wa",
                params: { 
                    invoiceId: data.idmasal_transaksi,
                    idoutlet: data.idoutlet,
                    penerima: data.penerima_wa,
                },
            })
        },
        // sendWa(data) {
        //     this.sendWaInvoice(data.idmasal_transaksi)
        //         .then((res) => {
        //             if (!res.status) {
        //                 this.$toast.error(res);
        //             } else {
        //                 let { code, data, status, msg } = res.data;
        //                 if (code === 200 && status) {
        //                     this.$toast.success(msg);
        //                     this.setResponse(resulter.successResult(msg));
        //                 } else {
        //                     this.$toast.error(msg);
        //                     this.setResponse(resulter.errorResult(msg));
        //                 }
        //             }
        //         })
        //         .catch((e) => {
        //             this.$toast.error(e);
        //             this.setResponse(resulter.errorResult(e));
        //         });
        // },
        goDeleteInvoice(invoice) {
            if (invoice.status_pembatalan !== 2) {
                this.$router.push({
                    name: "invoice.list.batal_invoice",
                    params: { invoiceId: invoice.idmasal_transaksi },
                    query: { idKaryawan: invoice.idkaryawan, isLunas: invoice.lunas === 1, nominal: invoice.terbayar },
                });
            } else {
                this.$router.push({
                    name: "invoice.list.hapus_invoice",
                    params: { invoiceId: invoice.idmasal_transaksi },
                    query: { idKaryawan: invoice.idkaryawan, isLunas: invoice.lunas === 1, nominal: invoice.terbayar },
                });
            }
        },
        async doLoadMore() {
            if (this.invoiceTotal > this.invoicePage.length) {
                if (!this.isLoadMore) {
                    await this.setLoadMore(true);
                    await this.loadData({ key: this.searchKey });
                    this.subscribeInvoice()
                }
            }
        },
        toggleCard(data) {
            this.toggleInvoiceShow(data);
        },
    },
};
</script>
<style scoped src="../static/style.css">
</style>
